export default defineNuxtRouteMiddleware((to) => {
  const { loggedIn } = useUserSession()

  if (!loggedIn.value) {
    return navigateTo({
      name: 'login',
      query: {
        redirectTo: to.fullPath,
      } satisfies RedirectToQuery,
    })
  }
})
